// removed by extract-text-webpack-plugin
module.exports = {"button":"CdfmkW6Q","color-0":"_2APMYl6r","color0":"_2APMYl6r","color-1":"_2i1n2Bdp","color1":"_2i1n2Bdp","color-2":"eLfEoOJv","color2":"eLfEoOJv","color-3":"_28UAi1Ir","color3":"_28UAi1Ir"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/Button.pcss
// module id = 385
// module chunks = 0